module.exports = __webpack_public_path__ + "img/brand5-head.649f6825.png";